import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA8rontgTakiPbz_wPjcafaY4s3P9dGt_c",
  authDomain: "targetwise-8c24c.firebaseapp.com",
  projectId: "targetwise-8c24c",
  storageBucket: "targetwise-8c24c.firebasestorage.app",
  messagingSenderId: "1054799373851",
  appId: "1:1054799373851:web:88eaffcccd1648a121fabe",
  measurementId: "G-QGX38D66ST"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
